export const UUID = {
    PREFIX: '00000000-0000-0000-0000-',
    SERVICE_ID: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0000',
    SERVICE_NAME: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0001',
    DEVICE_MODEL: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0002',
    WIFI_NAME: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0003',
    IP_ADDRESS: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0004',
    INPUT: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0005',
    NOTIFY_MESSAGE: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0006',
    INPUT_SEP: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0007',
    CUSTOM_COMMAND_INPUT: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0008',
    CUSTOM_COMMAND_NOTIFY: 'fd2b4448-aa0f-4a15-a62f-eb0be77a0009',
    CUSTOM_INFO_LABEL: 'fd2bccca',
    CUSTOM_INFO_COUNT: 'fd2bccaa0000',
    CUSTOM_INFO: 'fd2bcccb',
    CUSTOM_COMMAND_LABEL: 'fd2bcccc',
    CUSTOM_COMMAND_COUNT: 'fd2bccac0000'
};
